<template>
  <div ref="root" class="v5-pop-wrap">
    <button
      class="v5-ib"
      type="button"
      :aria-label="unseen.length ? t('v5.shell.notifications_unread', { n: unseen.length }) : t('v5.shell.notifications')"
      :aria-expanded="String(open)"
      aria-controls="v5-bell"
      @click="toggle"
    >
      <BellIcon class="i" aria-hidden="true" />
      <i v-if="unseen.length" class="v5-count num" aria-hidden="true">{{ unseen.length }}</i>
    </button>
    <div v-if="open" id="v5-bell" class="v5-pop v5-pop--wide">
      <div class="v5-pop__head">
        <h2>{{ t('v5.shell.notifications') }}</h2>
        <button v-if="unseen.length" class="v5-lnk" type="button" @click="emit('clear')">{{ t('v5.shell.clear_all') }}</button>
      </div>
      <ul v-if="unseen.length" class="v5-pop__rows v5-notes">
        <li v-for="n in unseen" :key="n.id">
          <img class="v5-notes__logo" :src="Icon" alt="">
          <a class="v5-notes__tx" :href="n.link || '#'" @click.prevent="go(n)">
            <small v-if="n.created_at">{{ ago(n.created_at) }}</small>
            <b>{{ n.title }}</b>
            <span>{{ n.description }}</span>
          </a>
          <button class="v5-ib" type="button" :aria-label="t('v5.shell.dismiss_named', { name: n.title })" @click="emit('see', n)">
            <XMarkIcon class="i" aria-hidden="true" />
          </button>
        </li>
      </ul>
      <div v-else class="v5-empty">
        <BellIcon class="i" aria-hidden="true" />
        <b>{{ t('v5.shell.no_notifications') }}</b>
        <span>{{ t('v5.shell.no_notifications_hint') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { BellIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import usePopover from './usePopover';
import { openNotificationLink } from '../../utils/notification_link';
import Icon from '../../assets/logos/refrag-icon-button.svg';

// The classic NotificationsPopup in v5 dress: same list, see and see-all calls (useV5Shell)
defineProps({ unseen: { type: Array, required: true } });
const emit = defineEmits(['see', 'clear']);
const { t } = useI18n();
const router = useRouter();
const { open, root, toggle } = usePopover();

function go(n) {
  emit('see', n);
  openNotificationLink(router, n.link);
}

function ago(createdAt) {
  const days = (Date.now() - new Date(createdAt)) / 86400000;
  return days < 1 ? t('v5.shell.today') : t('v5.shell.days_ago', { n: Math.ceil(days) });
}
</script>
